import { useAuth } from "../context/AuthContext";
import { useIdleSessionTimeout } from "../hooks/useIdleSessionTimeout";

const SessionTimeoutHandler = () => {
  const { isAuthenticated, logout, user } = useAuth();
  useIdleSessionTimeout(isAuthenticated, logout, user);
  return null;
};

export default SessionTimeoutHandler;
